export const wait = async (timeout?: number) => {
  if (timeout == null) {
    timeout = Math.random() * 375;
  }

  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), timeout);
  });
};
